/* globals urls, koisCustomerProfile, validate, ProfileHelper, RSVP */

(function($, ProfileHelper) {
	// If we're on the edit profile page, initialize any social media or education rows with proper click events
	if(ProfileHelper.page === 'edit'){
		// Initialize social rows on this page
		ProfileHelper.initSocRows();
		// Initialize education rows on this page
		ProfileHelper.initEduRows();
		// Remove any URL params, to keep the URL as clean as possible
		ProfileHelper.removeUpdateUrlParams();
	}

	// Disable submitting form when pressing the enter key. Submission & validation will be handled via AJAX
	$('form#customer-profile-edit').keypress( function( e ) {
		var code = e.keyCode || e.which;
		if( code === 13 ) {
			e.preventDefault();
			return false;
		}
	});

	//	NOTE: RUNS THIS WHEN SAVE BUTTON
	$('form#customer-profile-edit a.profile-save').click(function(e){

		e.preventDefault();
		if ($(this).attr('disabled')) {
			return;
		}
		
		$(this).addClass('loading').attr('disabled', true);
		clearRegistrationErrors();
		var objValidationPromise;

		//	get submitted form values
		var objProfileData = getProfileFormValues(true);

		//	get constraints for fields other than education and social media
		var objProfileConstraints = getProfileFormConstraints();

		// Initial check for HTML tags
		var objValidationResult = ProfileHelper.checkForTags(objProfileData);
		// If we didn't find any HTML tags, perform the rest of our validation
		if(!objValidationResult){
			objValidationResult = validate(objProfileData, objProfileConstraints);
			objValidationResult = validateEducationData(objValidationResult);
			objValidationResult = validateLegacySchoolData(objValidationResult);
			objValidationResult = validateSocialData(objValidationResult);
		}

		if(!objValidationResult)
		{
			//	validate profile slug
			objValidationPromise = validateProfileSlug();
		}

		//	if validation found a problem
		if(objValidationResult){
			showRegistrationErrors(objValidationResult);
		}
		else if(objValidationPromise){
			// Wait for promise to be fulfilled
		}
		else{
			 updateCustomer();
		}
	});

	// Add RSVP to validate.js to allow for async validation using Promises
	validate.Promise = RSVP.Promise;
	// Add custom async validator for checking if a username and email combination exist in the WP database
	validate.validators.profileSlugAsyncValidator = function(value) {
		return new validate.Promise(function(resolve, reject) {

			// User AJAX to call the custom WP REST API route
			$.ajax({
				type: 'POST',
				url: '/wp-json/profile-slug/v1/verify',
				data: {
					"profile-slug": value.profileSlug,
					"method-id": value.methodId
				}
			})
			// 200 response means they're both available
			.done(function() {
				resolve();
			})
			// Anything else is a failure, and the results will be parsed to display to the user
			.fail(function(jqXHR){
				var objResponse = $.parseJSON(jqXHR.responseText);
				reject(objResponse);
			});
		});
	};

	// Perform an asynchronous validation of the user's chosen username and email to make sure they're available
	function validateProfileSlug(){
		// On success, show the next step
		var success = function(){
			updateCustomer();
		};
		// On error, parse the resulting WP REST API response body to display relevant info for the impacted field(s)
		var error = function(error) {
			var objValidationError = {};
			if(error.code === 'duplicate_exists'){
				objValidationError.ProfileSlug = ['This profile slug is already taken. Please choose another.'];
			} else {
				objValidationError.ProfileSlug = [error.message];
			}
			showRegistrationErrors(objValidationError);
		};

		// Set up validation values and contraints
		var asyncValues = {
			slugValidForMethodUser: {
				profileSlug: $('#profile-slug-00').val(),
				methodId: $('#customer_external_record_id').val()
			}
		};
		var asyncConstraints = {
			slugValidForMethodUser: {
				profileSlugAsyncValidator: true
			}
		};

		// Perform async validation, passing success and error handlers to the resulting Promise to be run once it has been settled
		var promise = validate.async(asyncValues, asyncConstraints).then(success, error);

		// Wrap promise in an object with a simple flag so Promise objects are easily distinguishable from validation error objects
		return {isPromise: true, promise: promise};
	}

	// Submit data via ajax to attempt to update this customer
	function updateCustomer(){
		var objCustomerData = buildProfileUpdateData();

		$('#customer-profile-edit a.profile-save').prop('disabled', true).addClass('c-btn--disabled');

		// Make AJAX call to create this new customer
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: 'update_customer_profile', formData: objCustomerData, methodRecordId: $('input#customer_external_record_id').val(), currentUrl: urls.current }
		})
		.done(function( strResponse ) {
			var objResponse = $.parseJSON(strResponse);

			$('#customer-profile-edit .message-target').html(objResponse.message);

			$('#customer-profile-edit a.profile-save').prop('disabled', false).removeClass('c-btn--disabled');

			if(objResponse.success === true && objResponse.redirect_url){
				ProfileHelper.ignoreDataChanges = true;
				window.location = objResponse.redirect_url;
			}
			// Otherwise scroll to the top of the page so the user can see whatever message was returned
			else{
				window.scrollTo(0,0);
			}
		});
	}

	// Helper function to build the data needed to create a new customer
	function buildProfileUpdateData(){
		var form = document.querySelector("form#customer-profile-edit");
		var objCustomerData = validate.collectFormValues(form);
		var arrCustomerEducationRows = ProfileHelper.getEducationRowData();
		var arrCustomerEducationRecordsToDelete = ProfileHelper.getDeletedEduRecordIds();
		var arrCustomerSocialMediaRows = ProfileHelper.getSocialRowData();
		var arrCustomerSocialMediaRecordsToDelete = ProfileHelper.getDeletedSocRecordIds();

		var objUpdate = {
			customerData: objCustomerData,
			customerEducation: {
				customerEducationData: arrCustomerEducationRows
			},
			customerSocialMedia: {
				customerSocialMediaData: arrCustomerSocialMediaRows
			},
			copyBillingAddressFromOffice: $('#billing-box').prop('checked'),
			copyShippingAddressFromOffice: $('#shipping-box').prop('checked')
		};

		if(arrCustomerEducationRecordsToDelete){
			objUpdate.customerEducation.customerEducationDeleteRecords = arrCustomerEducationRecordsToDelete;
		}

		if(arrCustomerSocialMediaRecordsToDelete){
			objUpdate.customerSocialMedia.customerSocialMediaDeleteRecords = arrCustomerSocialMediaRecordsToDelete;
		}

		return objUpdate;
	}

	// If we're on the edit profile page, set up initial form data and set an onbeforeload event to prevent users from losing unsaved data
	if(ProfileHelper.page === 'edit'){
		// Cache the initial state of the form data for later comparison
		ProfileHelper.setInitProfileData(buildProfileUpdateData());
		// Check if the profile data has changed before a user navigates away or refreshes the page. If it has, show them an alert.
		// NOTE: Chrome and FireFox won't show the text below, but both have sensible default messages.
		window.onbeforeunload = function() {
			if(ProfileHelper.dataHasChanged(buildProfileUpdateData())){
				return "You have unsaved data. Are you sure you want to navigate away?";
			}
		};
	}

	function validateEducationData(objValidationResult){

		//	get data
		var arrEducationData = ProfileHelper.getEducationRowData();

		//	set constraints
		var objEducationConstraints = {
			DegreeType: {
				presence: true
			},
			School: {
				// presence: true,
				noTags: true
			},
			YearGraduated: {
				noTags: true
			},
			Degree: {
				noTags: true
			}
		};

		//	detect if invalid education row exist
		var blnInvalidEducationRow = false;
		var arrEducationValidationResults = $.map(arrEducationData, function(objEducationRow, i){
			var curValidationResult = validate(objEducationRow, objEducationConstraints);
			if(curValidationResult){
				blnInvalidEducationRow = true;
			}
			return curValidationResult || false;
		});

		//	if invalid education row found
		if(blnInvalidEducationRow){

			//	make sure var is at least an array
			objValidationResult = objValidationResult || {};

			//	set results
			objValidationResult.educationRows = arrEducationValidationResults;
		}

		return objValidationResult;
	}

	// Helper function to get the value of school if its a legacy school. If the user does not change it we'll accept the
	// value as it is, but if they change it they need to update it with a valid school from the select box
	function validateLegacySchoolData (objValidationResult) {
		var arrEducationRows = [];
		$('.edu-block').each(function(){
			var strDegreeSchool = $(this).find('.edu-college-input').val();
			var loadedValue = $(this).find('.edu-college-input').data('loadedValue');
			var collegeId = $(this).find('#edu-college-id-00').val();

			var objData = {
				loadedValue: loadedValue,
				School: (collegeId === "false" && loadedValue) ? strDegreeSchool : collegeId,
				collegeId: collegeId,
			};

			arrEducationRows.push(objData);
		});

		//	detect if invalid education row exist
		var blnInvalidEducationRow = false;
		var arrEducationValidationResults = $.map(arrEducationRows, function(objEducationRow, i){
			let constraints;
			if(objEducationRow.collegeId !== "false" || !objEducationRow.loadedValue){
				constraints = {
					School: {
						numericality: {
							greaterThan: 0,
							message: "is invalid. Please select a valid school from the dropdown.",
						}
					}
				};
			} else {
				constraints = {
					School: {
						equality: {
							attribute: "LoadedValue",
							message: "is invalid. Please select a valid school from the dropdown.",
						}
					}
				};
			}

			var curValidationResult = validate(
				{ School: objEducationRow.School.toLowerCase(), LoadedValue: objEducationRow.loadedValue.toLowerCase() }, 
				constraints
			);

			if(curValidationResult){
				blnInvalidEducationRow = true;
			}
			return curValidationResult || false;
		});

		//	if invalid education row found
		if(blnInvalidEducationRow){

			//	make sure var is at least an array
			objValidationResult = objValidationResult || {};

			//	set results
			objValidationResult.educationRows = arrEducationValidationResults;
		}

		return objValidationResult;
	}

	function validateSocialData(objValidationResult){
		var arrSocialData = ProfileHelper.getSocialRowData();
		var objSocialConstraints = {
			SocialNetwork: {
				presence: {
					message: ' not selected. Please select a network from the dropdown.'
				}
			},
			Link: {
				presence: true,
				url: {
					message: " invalid. Please ensure you include http:// or https:// in your url."
				}
			}
		};
		var blnInvalidSocialRow = false;
		var arrSocialValidationResults = $.map(arrSocialData, function(objSocialRow, i){
			var curValidationResult = validate(objSocialRow, objSocialConstraints);
			if(curValidationResult){
				blnInvalidSocialRow = true;
			}
			return curValidationResult || false;
		});

		if(blnInvalidSocialRow){
			objValidationResult = objValidationResult || {};
			objValidationResult.socialRows = arrSocialValidationResults;
		}

		return objValidationResult;
	}

	function getProfileFormValues(blnIncludeAddressCheckboxes){
		var form = document.querySelector("form#customer-profile-edit");
		var objProfileData = validate.collectFormValues(form);

		if(blnIncludeAddressCheckboxes){
			objProfileData.checkBillingAddressValues = !$('#billing-box').prop('checked');
			objProfileData.checkShippingAddressValues = !$('#shipping-box').prop('checked');
		}

		return objProfileData;
	}

	function getProfileFormConstraints(){
		var objConstraints = {
			// Overview Section
			Title:{ presence: true },
			FirstName:{
				presence: true,
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: 'cannot be all upper or lower case'
				}
			},
			LastName:{
				presence: true,
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: 'cannot be all upper or lower case'
				}
			},
			PreferredName:{
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: 'cannot be all upper or lower case'
				}
			},
			CustomerWebsite: { url: { message: 'link invalid. Please ensure you include http:// or https:// in the url.'}},
			OfficeContactEmail: { email: true },
			Email: { presence: true, email: true },
			OfficePhone: { presence: true },
			OfficeAddress1: { presence: true },
			OfficeAddressCity: {
				presence: true,
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: 'cannot be all upper or lower case'
				}
			},
			OfficeAddressCountry: { presence: true },
			OfficeAddressState: function(value, attributes, attr, options, constraints) {
				return !ProfileHelper.isUsOrCanada(attributes.OfficeAddressCountry) ? {} : {
					presence: true
				};
			},
			OfficeAddressRegion: function(value, attributes, attr, options, constraints) {
				return ProfileHelper.isUsOrCanada(attributes.OfficeAddressCountry) ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			OfficeAddressZip: { presence: true },
			// Billing/Shipping Section
			BillingAddressFirstName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			BillingAddressLastName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			BillingAddress1: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: true
				};
			},
			BillingAddressCity: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			BillingAddressCountry: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: true
				};
			},
			BillingAddressState: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues || !ProfileHelper.isUsOrCanada(attributes.BillingAddressCountry) ? {} : {
					presence: true
				};
			},
			BillingAddressRegion: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues || ProfileHelper.isUsOrCanada(attributes.BillingAddressCountry) ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			BillingAddressZip: function(value, attributes, attr, options, constraints) {
				return !attributes.checkBillingAddressValues ? {} : {
					presence: true
				};
			},
			ShippingAddressFirstName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			ShippingAddressLastName: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			ShippingAddress1: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: true
				};
			},
			ShippingAddressCity: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			ShippingAddressCountry: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: true
				};
			},
			ShippingAddressState: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues || !ProfileHelper.isUsOrCanada(attributes.ShippingAddressCountry) ? {} : {
					presence: true
				};
			},
			ShippingAddressRegion: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues || ProfileHelper.isUsOrCanada(attributes.ShippingAddressCountry) ? {} : {
					presence: true,
					format: {
						pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
						message: 'cannot be all upper or lower case'
					}
				};
			},
			ShippingAddressZip: function(value, attributes, attr, options, constraints) {
				return !attributes.checkShippingAddressValues ? {} : {
					presence: true
				};
			},
			// Professional Info Section
			CertificateName: {
				presence: true
			},
			DoctorSpecialty: {
				presence: true
			},
			AdvancedTrainingUniversity: function(value, attributes, attr, options, constraints) {
				return !ProfileHelper.isSpecialtyWithAdditionalFields(attributes.DoctorSpecialty) ? {} : {
					presence: true
				};
			},
			YearAdvancedTrainingComplete: function(value, attributes, attr, options, constraints) {
				return !ProfileHelper.isSpecialtyWithAdditionalFields(attributes.DoctorSpecialty) ? {} : {
					presence: true
				};
			},
			AgdNum: {
				numericality: {
					onlyInteger: true
				}
			},
			SharePersonalInfo: {
				presence: true
			},
			ProfileSlug: {
				format: {
			      pattern: "[A-Za-z0-9-]+",
			      message: "can only contain numbers, letters, or dashes"
			    },
			    length: {
			    	maximum: 80
			    }
			},
			//Personal/Profile Info Section
			PersonalBio: {
				length: {
					maximum: 3000
				},
				// if we ever upgrade to es9 this code should work
				// format: {
				// 	pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gs,
				// 	message: 'cannot be all upper or lower case'
				// }
			},
			YearBeganPractice: {
				length: {
					is: 4,
					tooShort: "Must be 4 characters",
					tooLong: "Must be 4 characters"
				},
				format: {
					pattern: /^(19|20)\d{2}$/,
					message: "^Must be in yyyy format, numbers only, and a valid year"
				}
			},
			Birthday: {
				format: {
					pattern: /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
				}
			},
			CryptoWalletAddress: {
				format: {
					pattern: /^(0x)[0-9a-f]{40}$/i,
					message: 'must be a valid Ethereum wallet address'
				}
			}
		};

		return objConstraints;
	}

	// Remove validation errors from the form
	function clearRegistrationErrors(){
		$('#customer-profile-edit .message-target').html('');
		$('.error').removeClass('error');
		$('span.validation-error').remove();
	}

	// Displays validation errors to the user based on the current step
	function showRegistrationErrors(objValidationResult){
		// Make AJAX call to render the twig message partial with a generic error message
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: 'generate_registration_error' }
		})
		.done(function( strResponse ) {
			var objResponse = $.parseJSON(strResponse);

			// Add the generic error message to the top of this step, and scroll the window there
			if(objResponse.success){
				$('#customer-profile-edit .message-target').html(objResponse.message);
				window.scrollTo(0,0);
			}
			// Highlight fields and add error messages based on objValidationResult
			addFieldValidationErrorStylesAndMessages(objValidationResult);

			// Remove submit button loading class and enable
			$('form#customer-profile-edit a.profile-save')
				.removeClass('loading')
				.attr('disabled', false);
		});
	}

	// Add validation error messages for each education row, based on validation results
	function addFieldValidationErrorStylesAndMessages(objValidationResult){
		var objAccordionIds = {acc1: 0, acc2: 0, acc3: 0, acc4: 0, acc5: 0};
		$.each(objValidationResult, function(key, value){
			var strAccordionId = fieldNameToAccordionId(key);
			if(strAccordionId){
				objAccordionIds[strAccordionId] = 1;
			}
			var strErrorMessage = '<span class="validation-error">'+value[0]+'</span>';
			var el;
			switch(key){
				// Dropdowns have a div wrapped around them, so they need to be handed differently
				case 'Title':
				case 'OfficeAddressCountry':
				case 'OfficeAddressState':
				case 'BillingAddressCountry':
				case 'BillingAddressState':
				case 'ShippingAddressCountry':
				case 'ShippingAddressState':
				case 'DoctorSpecialty':
					el = $('select[name="'+key+'"]').parent('.selectbox-container');
					el.addClass('error');
					el.prevAll('label').addClass('error');
					el.after(strErrorMessage);
					break;
				// Radio buttons have error classes/messages applied to their "parent" label
				case 'SharePersonalInfo':
					el = $('input[name="'+key+'"]').prevAll('label.required');
					el.addClass('error');
					el.after(strErrorMessage);
					break;
				// Education Row(s) are handled separately
				case 'educationRows':
					ProfileHelper.addEducationRowErrors(value);
					break;
				// Social Media Row(s) are handled separately
				case 'socialRows':
					ProfileHelper.addSocialRowErrors(value);
					break;
				case 'PersonalBio':
				case 'SpecialRequests':
					el = $('textarea[name="'+key+'"]');
					el.addClass('error');
					el.prevAll('label').addClass('error');
					el.after(strErrorMessage);
					break;
				// Normal inputs (e.g. text, email, password, etc...) have error class applied directly to input and label, and error message after the input
				case 'CryptoWalletAddress':
					el = $('input[name="'+key+'"]');
					el.addClass('error');
					$('label[for="crypto-wallet-address"]').addClass('error');
					el.after(strErrorMessage);
					break;
				default:
					el = $('input[name="'+key+'"]');
					el.addClass('error');
					el.prevAll('label').addClass('error');
					el.after(strErrorMessage);
					break;
			}
		});

		// Show/hide accordions as needed based on presence of validation errors
		$.each(objAccordionIds, function(key, value){
			var dt = $('form#customer-profile-edit dt[data-id="'+key+'"]');
			if((dt.hasClass('active') && value === 0) || (dt.hasClass('inactive') && value === 1)){
				dt.find('.tab-title a').trigger('click');
			}
		});
	}

	function fieldNameToAccordionId(strFieldName){
		var id;
		switch(strFieldName){
			case 'Title':
			case 'FirstName':
			case 'LastName':
			case 'OfficeName':
			case 'OfficeContactEmail':
			case 'OfficePhone':
			case 'OfficeFax':
			case 'CustomerWebsite':
			case 'OfficeAddress1':
			case 'OfficeAddress2':
			case 'OfficeAddressCity':
			case 'OfficeAddressCountry':
			case 'OfficeAddressState':
			case 'OfficeAddressRegion':
			case 'OfficeAddressZip':
			case 'PersonalBio':
			case 'socialRows':
			case 'educationRows':
			case 'CryptoWalletAddress':
				id = 'acc1';
				break;
			case 'BillingAddressFirstName':
			case 'BillingAddressLastName':
			case 'BillingAddress1':
			case 'BillingAddressCity':
			case 'BillingAddressCountry':
			case 'BillingAddressState':
			case 'BillingAddressRegion':
			case 'BillingAddressZip':
			case 'ShippingAddressFirstName':
			case 'ShippingAddressLastName':
			case 'ShippingAddress1':
			case 'ShippingAddressCity':
			case 'ShippingAddressCountry':
			case 'ShippingAddressState':
			case 'ShippingAddressRegion':
			case 'ShippingAddressZip':
				id = 'acc2';
				break;
			case 'PreferredName':
			case 'PronouncedName':
			case 'Phone':
			case 'CellPhone':
			case 'Email':
			case 'SpouseName':
			case 'ChildrensNames':
			case 'HometownCity':
			case 'HometownState':
			case 'HometownCountry':
			case 'GrewUpIn':
			case 'FoodAllergies':
			case 'SpecialRequests':
				id = 'acc3';
				break;
			case 'CertificateName':
			case 'DoctorSpecialty':
			case 'AdvancedTrainingUniversity':
			case 'YearAdvancedTrainingComplete':
			case 'AgdNum':
			case 'AdaNum':
			case 'OfficeContact':
			case 'YearBeganPractice':
				id = 'acc4';
				break;
			case 'SharePersonalInfo':
			case 'ProfileSlug':
				id = 'acc5';
				break;
		}
		return id;
	}

	// Trigger a change event on all country dropdowns and the specialty dropdown to ensure the correct fields are shown/hidden
	function initAddressAndSpecialtyFields(){
		$('select.country-dropdown').trigger('change');
		$('select#prof-specialty').trigger('change');
	}
	// Wait until the page has loaded, then determine the initial state of the address/specialty fields
	$(document).ready(function(){
		initAddressAndSpecialtyFields();
	});

	// we want to obfuscate the crypto/nft wallet address initially
	// we keep the obfuscated value in a "fake" input field for display
	// purposes and if the user wants to edit it, we hide the fake field
	// and show the real field
	$('.btn-wallet-edit').on('click', function(e){
		e.preventDefault();

		$('.wallet-address-obf').addClass('hidden');
		$('.wallet-address-input').removeClass('hidden');
		$('.wallet-address-input').trigger('focus');


		$(this).addClass('c-btn--disabled');
	});

	// faking an anchor tag link to get to the cryptowallet input field
	// because it is nested in a collapsed accordion. We need to expand
	// the accordion then jump to it.
	// /my-account/edit/?nftWallet=true
	let searchParams = new URLSearchParams(window.location.search);
	if(searchParams.has('nftWallet')){

		let accordionButton = $('.js-profile-info-acc');
		accordionButton.removeClass('inactive');
		accordionButton.addClass('active');

		$('.js-profile-info-form').css("display", "block");

		
		setTimeout(() => {
		var element = document.getElementById('crypto-wallet-address');
		const y = element.getBoundingClientRect().top + window.scrollY;
			window.scroll({
				top: y-100,
				behavior: 'smooth'
			});
			$('#crypto-wallet-address').focus();
		  }, 500);
		

	}


})(jQuery, new ProfileHelper(koisCustomerProfile.template));
